// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3Nl7J","signatureButtonsRight":"ModalSign_signatureButtonsRight__2oMFH"};